import React from 'react';
import {
    Container,
    Grid,
    Typography,
    makeStyles
} from '@material-ui/core';
import Page from 'components/Page';
import { useTranslation } from "react-i18next";
import ParcelshopTable from './ParcelshopTable';

const useStyles = makeStyles((theme) => ({
    root: {
    }
}));

export default function ParcelshopView() {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Page
            className={classes.root}
            title={t('navbar.parcelshop')}
        >
            <Container maxWidth={false}>
                <Typography variant="h1" gutterBottom >
                    {t('navbar.parcelshop')}
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <ParcelshopTable/>
                    </Grid>
                </Grid>
            </Container>
        </Page>
    );
}